// extracted by mini-css-extract-plugin
export default {"header":"dV-z","logo":"eV-z","signin":"fV-z"};